// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'peekpanel-arrow-left';

export const Component = () => (
  <path d='M5.885 0s1.962.878 1.962 1.962v20.597a1.962 1.962 0 0 1-1.962 1.962H1.962A1.962 1.962 0 0 1 0 22.56V1.962C0 .878.878 0 1.962 0h3.923Zm0 1.962H1.962v20.597h3.923V1.962Zm9.23 9.795h8.437c.59 0 .968.38.968.97 0 .613-.368 1.018-.968 1.018h-8.436l3.17 3.178c.25.143.347.416.347.743 0 .591-.38.97-.968.97-.26 0-.495-.1-.681-.287l-4.926-4.89-.093-.129c-.131-.263-.195-.433-.195-.603 0-.15.04-.247.195-.554l.093-.13 4.926-4.89a.946.946 0 0 1 .68-.287c.59 0 .968.38.968.97 0 .312-.115.58-.362.744l-3.157 3.178.001-.001Z' />
);

export const viewBox = '0 0 25 25';
